const sideRoute = [
  {
    name: "Home",
    link: "",
    icon: "book",
  },
  {
    name: "Job Listing",
    link: "job_listing",
    icon: "bar-chart-square",
  },
];

export default sideRoute;
